import LogService from "../CommonSdk/LogService";
import RainbowServerFetch from "../Request/RainbowServerFetch";
import * as ErrorUtils from "../Utils/ErrorUtils";

const LOG_TAG = "SERVICE:USER";

export const updateUserPassword = (userId, oldPassword, newPassword) => {
    LogService.trace(LOG_TAG, "updateUserPassword", "enter");

    const body = JSON.stringify({
        oldPassword: oldPassword,
        newPassword: newPassword
    });

    return RainbowServerFetch.put("/api/rainbow/enduser/v1.0/users/" + userId + "/change-password", body)
        .then(response => {
            LogService.info(LOG_TAG, "updateUserPassword", "successfully updating pwd");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "updatePassword", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        })
}

export const getUserCustomData = () => {
    LogService.trace(LOG_TAG, "getUserCustomData", "enter");

    return RainbowServerFetch.get("/api/rainbow/applications/v1.0/users/custom-data")
        .then(json => {
            LogService.info(LOG_TAG, "getUserCustomData success");
            return Promise.resolve(json.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getUserCustomData", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const setUserCustomData = (customData) => {
    LogService.trace(LOG_TAG, "setUserCustomData", "enter");

    const body = JSON.stringify({
        customData: customData
    });

    return RainbowServerFetch.put("/api/rainbow/applications/v1.0/users/custom-data", body)
        .then(json => {
            LogService.info(LOG_TAG, "setUserCustomData success");
            return Promise.resolve(json.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "setUserCustomData", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

